import { render, staticRenderFns } from "./CustomerIndividualForm.vue?vue&type=template&id=6a770f8f&scoped=true"
import script from "./CustomerIndividualForm.vue?vue&type=script&lang=js"
export * from "./CustomerIndividualForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a770f8f",
  null
  
)

export default component.exports